module.exports = __webpack_public_path__ + "img/SKMJ_lift8.ebec6fdf.jpg";